import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createSlots as _createSlots, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  style: {"display":"inline-flex"}
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  style: {"display":"inline-flex"}
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 0,
  style: {"display":"inline-flex"}
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 0,
  style: {"display":"inline-flex"}
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 0,
  style: {"display":"inline-flex"}
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 0,
  style: {"display":"inline-flex"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_ParticipantHeader = _resolveComponent("ParticipantHeader")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_DocumentList = _resolveComponent("DocumentList")!
  const _component_ValidationAlert = _resolveComponent("ValidationAlert")!
  const _component_AddEligibilityNoteDialog = _resolveComponent("AddEligibilityNoteDialog")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_AlternateWorkflowSubmission = _resolveComponent("AlternateWorkflowSubmission")!
  const _component_WorkflowHistory = _resolveComponent("WorkflowHistory")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_AddAddressDialog = _resolveComponent("AddAddressDialog")!
  const _component_AddEmailDialog = _resolveComponent("AddEmailDialog")!
  const _component_AddPhoneDialog = _resolveComponent("AddPhoneDialog")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_ctx.isLoading)
    ? (_openBlock(), _createBlock(_component_v_container, {
        key: 0,
        fluid: "",
        style: {"display":"inline-grid","justify-content":"center"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_progress_circular, {
            size: 70,
            width: 7,
            color: "loading",
            indeterminate: ""
          })
        ]),
        _: 1
      }))
    : (!_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_v_container, {
          key: 1,
          fluid: ""
        }, {
          default: _withCtx(() => [
            (_ctx.headerData && !_ctx.errorMessage)
              ? (_openBlock(), _createBlock(_component_ParticipantHeader, {
                  key: 0,
                  data: _ctx.headerData
                }, null, 8, ["data"]))
              : _createCommentVNode("", true),
            _createVNode(_component_v_spacer, { class: "mt-6" }),
            _createVNode(_component_v_toolbar, {
              color: "secondary",
              elevation: 8
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  icon: "mdi-arrow-left",
                  density: "comfortable",
                  variant: "plain",
                  onClick: _ctx.returnToList
                }, null, 8, ["onClick"]),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_toolbar_title, { style: {"margin-right":"15em"} }, {
                  default: _withCtx(() => [...(_cache[60] || (_cache[60] = [
                    _createTextVNode("Enter Data For Participant", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_spacer, { class: "mt-6" }),
            _createVNode(_component_v_form, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_expansion_panels, {
                  multiple: "",
                  modelValue: _ctx.panel,
                  "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.panel) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_expansion_panel, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_expansion_panel_title, { class: "text-h5" }, {
                          default: _withCtx(() => [...(_cache[61] || (_cache[61] = [
                            _createTextVNode("Eligibility Info", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_v_expansion_panel_text, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_form, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      sm: "12",
                                      md: "4"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_text_field, {
                                          type: "date",
                                          label: "Start Date",
                                          modelValue: _ctx.eligibility.startDateForEdit,
                                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.eligibility.startDateForEdit) = $event)),
                                          disabled: !_ctx.canEnterData
                                        }, null, 8, ["modelValue", "disabled"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      sm: "12",
                                      md: "4"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_text_field, {
                                          type: "date",
                                          label: "End Date",
                                          modelValue: _ctx.eligibility.endDateForEdit,
                                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.eligibility.endDateForEdit) = $event)),
                                          disabled: !_ctx.canEnterData
                                        }, null, 8, ["modelValue", "disabled"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      sm: "12",
                                      md: "4"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_text_field, {
                                          type: "date",
                                          label: "Projected Completion Date",
                                          modelValue: _ctx.eligibility.completionDateForEdit,
                                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.eligibility.completionDateForEdit) = $event)),
                                          disabled: !_ctx.canEnterData
                                        }, null, 8, ["modelValue", "disabled"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_expansion_panel, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_expansion_panel_title, { class: "text-h5" }, {
                          default: _withCtx(() => [...(_cache[62] || (_cache[62] = [
                            _createTextVNode("Demographic Information", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_v_expansion_panel_text, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_autocomplete, {
                                      multiple: "",
                                      clearable: _ctx.canEnterData,
                                      items: _ctx.raceSelectItems,
                                      "item-value": "id",
                                      "item-title": "description",
                                      label: "Select Race",
                                      modelValue: _ctx.raceSelections,
                                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.raceSelections) = $event)),
                                      readonly: !_ctx.canEnterData
                                    }, null, 8, ["clearable", "items", "modelValue", "readonly"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  md: "4"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_select, {
                                      items: _ctx.ethnicitySelectItems,
                                      "item-value": "id",
                                      "item-title": "description",
                                      label: "Select Ethnicity",
                                      modelValue: _ctx.eligibility.participantDemographic.ethnicityId,
                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.eligibility.participantDemographic.ethnicityId) = $event)),
                                      readonly: !_ctx.canEnterData
                                    }, null, 8, ["items", "modelValue", "readonly"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  md: "4"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_select, {
                                      items: _ctx.employmentSelectItems,
                                      "item-value": "id",
                                      "item-title": "description",
                                      label: "Select Employment Status",
                                      modelValue: _ctx.eligibility.participantDemographic.employmentStatusId,
                                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.eligibility.participantDemographic.employmentStatusId) = $event)),
                                      readonly: !_ctx.canEnterData
                                    }, {
                                      selection: _withCtx(({ item }) => [
                                        _createElementVNode("span", null, _toDisplayString(item.title?.split(':')[0] ?? ""), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["items", "modelValue", "readonly"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  md: "4"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_select, {
                                      items: _ctx.incomeSelectItems,
                                      "item-value": "id",
                                      "item-title": "description",
                                      label: "Select Estimated Annual Income",
                                      modelValue: _ctx.eligibility.participantDemographic.annualIncomeId,
                                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.eligibility.participantDemographic.annualIncomeId) = $event)),
                                      readonly: !_ctx.canEnterData
                                    }, null, 8, ["items", "modelValue", "readonly"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            (_ctx.isEmployed)
                              ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      md: "4"
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      md: "4"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_text_field, {
                                          label: "Enter Hourly Income",
                                          type: "number",
                                          onKeypress: _cache[7] || (_cache[7] = ($event: any) => (_ctx.filterOnlyNumbers($event))),
                                          prefix: "$",
                                          modelValue: _ctx.eligibility.participantDemographic.hourlyIncome,
                                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.eligibility.participantDemographic.hourlyIncome) = $event)),
                                          modelModifiers: { number: true },
                                          rules: (_ctx.isEmployed) ? _ctx.requiredRules : [],
                                          "error-messages": _ctx.incomeErrors,
                                          readonly: !_ctx.canEnterData
                                        }, null, 8, ["modelValue", "rules", "error-messages", "readonly"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      md: "4"
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  md: "4"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_select, {
                                      items: _ctx.educationSelectItems,
                                      "item-value": "id",
                                      "item-title": "description",
                                      label: "Select Highest Completed Education",
                                      modelValue: _ctx.eligibility.participantDemographic.highestCompletedEducationId,
                                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.eligibility.participantDemographic.highestCompletedEducationId) = $event)),
                                      readonly: !_ctx.canEnterData
                                    }, null, 8, ["items", "modelValue", "readonly"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  md: "4"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_select, {
                                      items: _ctx.militaryStatusSelectItems,
                                      "item-value": "id",
                                      "item-title": "description",
                                      label: "Select Military Status",
                                      modelValue: _ctx.eligibility.participantDemographic.militaryStatusId,
                                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.eligibility.participantDemographic.militaryStatusId) = $event)),
                                      readonly: !_ctx.canEnterData
                                    }, null, 8, ["items", "modelValue", "readonly"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  md: "4"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_select, {
                                      items: _ctx.adaStatusSelectItems,
                                      "item-value": "id",
                                      "item-title": "description",
                                      label: "Select ADA Status",
                                      modelValue: _ctx.eligibility.participantDemographic.adaStatusId,
                                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.eligibility.participantDemographic.adaStatusId) = $event)),
                                      readonly: !_ctx.canEnterData
                                    }, null, 8, ["items", "modelValue", "readonly"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  md: "4"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                      label: "Enter Driver's License Number",
                                      modelValue: _ctx.eligibility.participantDemographic.driversLicenseNumber,
                                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.eligibility.participantDemographic.driversLicenseNumber) = $event)),
                                      readonly: !_ctx.canEnterData
                                    }, null, 8, ["modelValue", "readonly"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  md: "4"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_checkbox, {
                                      label: "Can Participant Be Classified As An Adult?",
                                      modelValue: _ctx.eligibility.participantDemographic.isAdult,
                                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.eligibility.participantDemographic.isAdult) = $event)),
                                      readonly: !_ctx.canEnterData
                                    }, null, 8, ["modelValue", "readonly"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  md: "4"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                      type: "number",
                                      min: 0,
                                      max: 120,
                                      onKeypress: _cache[14] || (_cache[14] = ($event: any) => (_ctx.filterOnlyNumbers($event))),
                                      label: "Age of first contact w/ Justice System",
                                      modelValue: _ctx.eligibility.participantDemographic.ageAtFirstJusticeSystemEntry,
                                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.eligibility.participantDemographic.ageAtFirstJusticeSystemEntry) = $event)),
                                      modelModifiers: { number: true },
                                      readonly: !_ctx.canEnterData
                                    }, null, 8, ["modelValue", "readonly"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  md: "6"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                      type: "number",
                                      min: 0,
                                      max: 120,
                                      onKeypress: _cache[16] || (_cache[16] = ($event: any) => (_ctx.filterOnlyNumbers($event))),
                                      label: "Age of first substance use",
                                      modelValue: _ctx.eligibility.participantDemographic.ageAtFirstSubstanceUse,
                                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.eligibility.participantDemographic.ageAtFirstSubstanceUse) = $event)),
                                      modelModifiers: { number: true },
                                      readonly: !_ctx.canEnterData
                                    }, null, 8, ["modelValue", "readonly"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  md: "6"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_select, {
                                      items: _ctx.substanceSelectItems,
                                      "item-value": "id",
                                      "item-title": "description",
                                      label: "Substance used",
                                      modelValue: _ctx.eligibility.participantDemographic.firstSubstanceUsedId,
                                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.eligibility.participantDemographic.firstSubstanceUsedId) = $event)),
                                      readonly: !_ctx.canEnterData
                                    }, null, 8, ["items", "modelValue", "readonly"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  md: "6"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                      type: "number",
                                      min: "0",
                                      onKeypress: _cache[19] || (_cache[19] = ($event: any) => (_ctx.filterOnlyNumbers($event))),
                                      label: "Enter Number Of Dependents",
                                      modelValue: _ctx.eligibility.participantDemographic.numberOfDependents,
                                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.eligibility.participantDemographic.numberOfDependents) = $event)),
                                      readonly: !_ctx.canEnterData
                                    }, null, 8, ["modelValue", "readonly"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  md: "6"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                      type: "number",
                                      min: "0",
                                      onKeypress: _cache[21] || (_cache[21] = ($event: any) => (_ctx.filterOnlyNumbers($event))),
                                      label: "Number Of Drug-Free Children Born In Program",
                                      placeholder: "",
                                      modelValue: _ctx.eligibility.participantDemographic.drugFreeChildrenBorn,
                                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.eligibility.participantDemographic.drugFreeChildrenBorn) = $event)),
                                      readonly: !_ctx.canEnterData
                                    }, null, 8, ["modelValue", "readonly"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  md: "6"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                      type: "number",
                                      min: "0",
                                      max: "99",
                                      onKeypress: _cache[23] || (_cache[23] = ($event: any) => (_ctx.filterOnlyNumbers($event))),
                                      label: "# of dependent children living with the participant at entry",
                                      modelValue: _ctx.eligibility.participantDemographic.dependentChildrenAtEntryToProgram,
                                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.eligibility.participantDemographic.dependentChildrenAtEntryToProgram) = $event)),
                                      readonly: !_ctx.canEnterData
                                    }, null, 8, ["modelValue", "readonly"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  md: "6"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                      type: "number",
                                      min: 0,
                                      max: 99,
                                      onKeypress: _cache[25] || (_cache[25] = ($event: any) => (_ctx.filterOnlyNumbers($event))),
                                      label: "# of dependents not living with participant",
                                      modelValue: _ctx.eligibility.participantDemographic.dependentsNotLivingWithParticipant,
                                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.eligibility.participantDemographic.dependentsNotLivingWithParticipant) = $event)),
                                      modelModifiers: { number: true },
                                      readonly: !_ctx.canEnterData
                                    }, null, 8, ["modelValue", "readonly"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  sm: "6",
                                  md: "6"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_select, {
                                      items: _ctx.yesNoNaOptions,
                                      "item-value": "id",
                                      "item-title": "description",
                                      label: "Child Custody and Support Obligations?",
                                      modelValue: _ctx.eligibility.participantDemographic.yesNoNaId,
                                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.eligibility.participantDemographic.yesNoNaId) = $event)),
                                      readonly: !_ctx.canEnterData
                                    }, null, 8, ["items", "modelValue", "readonly"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  sm: "6",
                                  md: "6"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_select, {
                                      items: _ctx.filteredChildCustodyItems,
                                      "item-value": "id",
                                      "item-title": "description",
                                      label: "Select Child Custody",
                                      "onUpdate:modelValue": [
                                        _cache[28] || (_cache[28] = ($event: any) => (_ctx.childCustodySupportErrors = [])),
                                        _cache[29] || (_cache[29] = ($event: any) => ((_ctx.eligibility.participantDemographic.childCustodyId) = $event))
                                      ],
                                      modelValue: _ctx.eligibility.participantDemographic.childCustodyId,
                                      readonly: !_ctx.canEnterData,
                                      required: _ctx.isChildSupportYes,
                                      rules: _ctx.isChildSupportYes ? _ctx.requiredRules : [],
                                      "error-messages": _ctx.childCustodySupportErrors
                                    }, null, 8, ["items", "modelValue", "readonly", "required", "rules", "error-messages"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            (_ctx.isChildSupportYes || (_ctx.isChildCustodyYes))
                              ? (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      md: "6"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_text_field, {
                                          type: "number",
                                          min: "0",
                                          prefix: "$",
                                          onKeypress: _cache[30] || (_cache[30] = ($event: any) => (_ctx.filterOnlyNumbers($event))),
                                          "onUpdate:modelValue": [
                                            _cache[31] || (_cache[31] = ($event: any) => (_ctx.monthlySupportErrors = [])),
                                            _cache[32] || (_cache[32] = ($event: any) => ((_ctx.eligibility.participantDemographic.monthlySupportAmount) = $event))
                                          ],
                                          label: "Monthly payment for support",
                                          modelValue: _ctx.eligibility.participantDemographic.monthlySupportAmount,
                                          modelModifiers: { number: true },
                                          readonly: !_ctx.canEnterData,
                                          required: _ctx.isChildSupportYes,
                                          rules: _ctx.isChildSupportYes ? _ctx.requiredRules : [],
                                          "error-messages": _ctx.monthlySupportErrors
                                        }, null, 8, ["modelValue", "readonly", "required", "rules", "error-messages"])
                                      ]),
                                      _: 1
                                    }),
                                    (!_ctx.isFullCustodyOrRefused && _ctx.isChildCustodyYes)
                                      ? (_openBlock(), _createBlock(_component_v_col, {
                                          key: 0,
                                          cols: "12",
                                          md: "6"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_select, {
                                              items: _ctx.childCustodyHolderSelectItems,
                                              "item-value": "id",
                                              "item-title": "description",
                                              label: "Child custody holder",
                                              "onUpdate:modelValue": [
                                                _cache[33] || (_cache[33] = ($event: any) => (_ctx.childCustodyHolderErrors = [])),
                                                _cache[34] || (_cache[34] = ($event: any) => ((_ctx.eligibility.participantDemographic.childCustodyHolderId) = $event))
                                              ],
                                              modelValue: _ctx.eligibility.participantDemographic.childCustodyHolderId,
                                              readonly: !_ctx.canEnterData,
                                              required: _ctx.isChildCustodyYes,
                                              rules: _ctx.isChildCustodyYes ? _ctx.requiredRules : [],
                                              "error-messages": _ctx.childCustodyHolderErrors
                                            }, null, 8, ["items", "modelValue", "readonly", "required", "rules", "error-messages"])
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  sm: "6",
                                  md: "6"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_select, {
                                      items: _ctx.housingStatusSelectItems,
                                      "item-value": "id",
                                      "item-title": "description",
                                      label: "Select Housing Status",
                                      modelValue: _ctx.eligibility.participantDemographic.housingStatusId,
                                      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.eligibility.participantDemographic.housingStatusId) = $event)),
                                      readonly: !_ctx.canEnterData
                                    }, null, 8, ["items", "modelValue", "readonly"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  sm: "6",
                                  md: "6"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_select, {
                                      items: _ctx.maritalStatusSelectItems,
                                      "item-value": "id",
                                      "item-title": "description",
                                      label: "Select Marital Status",
                                      modelValue: _ctx.eligibility.participantDemographic.maritalStatusId,
                                      "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.eligibility.participantDemographic.maritalStatusId) = $event)),
                                      readonly: !_ctx.canEnterData
                                    }, null, 8, ["items", "modelValue", "readonly"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_expansion_panel, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_expansion_panel_title, { class: "text-h5" }, {
                          default: _withCtx(() => [...(_cache[63] || (_cache[63] = [
                            _createTextVNode("Participant Dependent Relationships", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_data_table, {
                                  headers: _ctx.dependentHeaders,
                                  items: _ctx.eligibility.participantDependents
                                }, {
                                  [`item.relationship`]: _withCtx(({ item }) => [
                                    _createVNode(_component_v_select, {
                                      items: _ctx.relationshipSelectItems,
                                      "item-value": "id",
                                      "item-title": "description",
                                      modelValue: item.relationshipId,
                                      "onUpdate:modelValue": ($event: any) => ((item.relationshipId) = $event),
                                      readonly: !_ctx.canEnterData
                                    }, null, 8, ["items", "modelValue", "onUpdate:modelValue", "readonly"])
                                  ]),
                                  [`item.dependentName`]: _withCtx(({ item }) => [
                                    _createVNode(_component_v_text_field, {
                                      type: "string",
                                      modelValue: item.dependentName,
                                      "onUpdate:modelValue": ($event: any) => ((item.dependentName) = $event),
                                      readonly: !_ctx.canEnterData
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly"])
                                  ]),
                                  [`item.actions`]: _withCtx(({ item, index }) => [
                                    (_ctx.canDelete || !item.participantDependentId)
                                      ? (_openBlock(), _createBlock(_component_v_btn, {
                                          key: 0,
                                          onClick: ($event: any) => (_ctx.removeDependent(index)),
                                          density: "comfortable",
                                          size: "small",
                                          icon: "mdi-delete",
                                          color: "info"
                                        }, null, 8, ["onClick"]))
                                      : _createCommentVNode("", true),
                                    (_ctx.eligibility.participantDependents.findIndex(e => e === item) === _ctx.eligibility.participantDependents.length - 1)
                                      ? (_openBlock(), _createBlock(_component_v_btn, {
                                          key: 1,
                                          onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.addDependent())),
                                          density: "comfortable",
                                          size: "small",
                                          icon: "mdi-plus",
                                          color: "info",
                                          disabled: !_ctx.canAddDependent
                                        }, null, 8, ["disabled"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1032, ["headers", "items"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_expansion_panel, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_expansion_panel_title, { class: "text-h5" }, {
                          default: _withCtx(() => [...(_cache[64] || (_cache[64] = [
                            _createTextVNode("Contact Information", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_v_expansion_panel_text, null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eligibility.participantContactInformations, (contactInfo, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: contactInfo.participantContactInformationId
                              }, [
                                _createVNode(_component_v_row, { justify: "space-between" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "4" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_select, {
                                          items: _ctx.contactTypeSelectItems,
                                          "item-value": "id",
                                          "item-title": "description",
                                          label: "Select Contact Type",
                                          modelValue: contactInfo.contactTypeId,
                                          "onUpdate:modelValue": ($event: any) => ((contactInfo.contactTypeId) = $event),
                                          readonly: !_ctx.canEnterData
                                        }, null, 8, ["items", "modelValue", "onUpdate:modelValue", "readonly"])
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_v_col, {
                                      cols: "4",
                                      style: {"text-align":"end"}
                                    }, {
                                      default: _withCtx(() => [
                                        (_ctx.canDelete || !contactInfo.participantContactInformationId)
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 0,
                                              onClick: ($event: any) => (_ctx.removeContactObject(index)),
                                              density: "comfortable",
                                              size: "small",
                                              icon: "",
                                              color: "info"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_tooltip, {
                                                  activator: "parent",
                                                  location: "bottom"
                                                }, {
                                                  default: _withCtx(() => [...(_cache[65] || (_cache[65] = [
                                                    _createTextVNode(" Delete this entire contact area ", -1)
                                                  ]))]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_icon, null, {
                                                  default: _withCtx(() => [...(_cache[66] || (_cache[66] = [
                                                    _createTextVNode("mdi-delete", -1)
                                                  ]))]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }, 8, ["onClick"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_data_table, {
                                          headers: _ctx.addressHeaders,
                                          items: [contactInfo.associatedAddress],
                                          density: "comfortable",
                                          class: "elevation-1",
                                          "hide-default-footer": ""
                                        }, {
                                          "header.actions": _withCtx(({ column }) => [
                                            _createTextVNode(_toDisplayString(column.title) + " ", 1),
                                            (_ctx.canAddAddress(index, false))
                                              ? (_openBlock(), _createBlock(_component_v_btn, {
                                                  key: 0,
                                                  density: "comfortable",
                                                  size: "x-small",
                                                  icon: "",
                                                  color: "info",
                                                  onClick: ($event: any) => (_ctx.addAddress(index, false))
                                                }, {
                                                  default: _withCtx(() => [
                                                    (_ctx.canAddAddress(index, false))
                                                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                                          key: 0,
                                                          activator: "parent",
                                                          location: "bottom"
                                                        }, {
                                                          default: _withCtx(() => [...(_cache[67] || (_cache[67] = [
                                                            _createTextVNode(" Add an address line (limited to one) ", -1)
                                                          ]))]),
                                                          _: 1
                                                        }))
                                                      : _createCommentVNode("", true),
                                                    _createVNode(_component_v_icon, null, {
                                                      default: _withCtx(() => [...(_cache[68] || (_cache[68] = [
                                                        _createTextVNode("mdi-plus", -1)
                                                      ]))]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 2
                                                }, 1032, ["onClick"]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          "item.isActive": _withCtx(({ item }) => [
                                            item
                                              ? (_openBlock(), _createElementBlock("tr", _hoisted_1, [
                                                  _createElementVNode("td", null, _toDisplayString(item.isActive ? 'Yes' : 'No'), 1)
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          "item.actions": _withCtx(({ item }) => [
                                            item
                                              ? (_openBlock(), _createElementBlock("tr", _hoisted_2, [
                                                  _createElementVNode("td", null, [
                                                    (_ctx.canEnterData)
                                                      ? (_openBlock(), _createBlock(_component_v_btn, {
                                                          key: 0,
                                                          onClick: ($event: any) => (_ctx.editAddress(item, index, false)),
                                                          density: "comfortable",
                                                          size: "small",
                                                          icon: "",
                                                          color: "info"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_tooltip, {
                                                              activator: "parent",
                                                              location: "bottom"
                                                            }, {
                                                              default: _withCtx(() => [...(_cache[69] || (_cache[69] = [
                                                                _createTextVNode(" Edit this line ", -1)
                                                              ]))]),
                                                              _: 1
                                                            }),
                                                            _createVNode(_component_v_icon, null, {
                                                              default: _withCtx(() => [...(_cache[70] || (_cache[70] = [
                                                                _createTextVNode("mdi-pencil", -1)
                                                              ]))]),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _: 1
                                                        }, 8, ["onClick"]))
                                                      : _createCommentVNode("", true),
                                                    (_ctx.canDelete || !item.addressId)
                                                      ? (_openBlock(), _createBlock(_component_v_btn, {
                                                          key: 1,
                                                          onClick: ($event: any) => (_ctx.removeAddress(index, false)),
                                                          density: "comfortable",
                                                          size: "small",
                                                          icon: "",
                                                          color: "info"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_tooltip, {
                                                              activator: "parent",
                                                              location: "bottom"
                                                            }, {
                                                              default: _withCtx(() => [...(_cache[71] || (_cache[71] = [
                                                                _createTextVNode(" Delete this line ", -1)
                                                              ]))]),
                                                              _: 1
                                                            }),
                                                            _createVNode(_component_v_icon, null, {
                                                              default: _withCtx(() => [...(_cache[72] || (_cache[72] = [
                                                                _createTextVNode("mdi-delete", -1)
                                                              ]))]),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _: 1
                                                        }, 8, ["onClick"]))
                                                      : _createCommentVNode("", true)
                                                  ])
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          bottom: _withCtx(() => [...(_cache[73] || (_cache[73] = []))]),
                                          _: 2
                                        }, 1032, ["headers", "items"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      md: "6"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_data_table, {
                                          headers: _ctx.emailHeaders,
                                          items: [contactInfo.associatedEmail],
                                          density: "comfortable",
                                          class: "elevation-1",
                                          "hide-default-footer": ""
                                        }, {
                                          "header.actions": _withCtx(({ column }) => [
                                            _createTextVNode(_toDisplayString(column.title) + " ", 1),
                                            (_ctx.canAddEmail(index, false))
                                              ? (_openBlock(), _createBlock(_component_v_btn, {
                                                  key: 0,
                                                  density: "comfortable",
                                                  size: "x-small",
                                                  icon: "",
                                                  color: "info",
                                                  onClick: ($event: any) => (_ctx.addEmail(index, false))
                                                }, {
                                                  default: _withCtx(() => [
                                                    (_ctx.canAddEmail(index, false))
                                                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                                          key: 0,
                                                          activator: "parent",
                                                          location: "bottom"
                                                        }, {
                                                          default: _withCtx(() => [...(_cache[74] || (_cache[74] = [
                                                            _createTextVNode(" Add an email line (limited to one) ", -1)
                                                          ]))]),
                                                          _: 1
                                                        }))
                                                      : _createCommentVNode("", true),
                                                    _createVNode(_component_v_icon, null, {
                                                      default: _withCtx(() => [...(_cache[75] || (_cache[75] = [
                                                        _createTextVNode("mdi-plus", -1)
                                                      ]))]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 2
                                                }, 1032, ["onClick"]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          "item.isActive": _withCtx(({ item }) => [
                                            item
                                              ? (_openBlock(), _createElementBlock("tr", _hoisted_3, [
                                                  _createElementVNode("td", null, _toDisplayString(item.isActive ? 'Yes' : 'No'), 1)
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          "item.actions": _withCtx(({ item }) => [
                                            item
                                              ? (_openBlock(), _createElementBlock("tr", _hoisted_4, [
                                                  _createElementVNode("td", null, [
                                                    (_ctx.canEnterData)
                                                      ? (_openBlock(), _createBlock(_component_v_btn, {
                                                          key: 0,
                                                          onClick: ($event: any) => (_ctx.editEmail(item, index, false)),
                                                          density: "comfortable",
                                                          size: "small",
                                                          icon: "",
                                                          color: "info"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_tooltip, {
                                                              activator: "parent",
                                                              location: "bottom"
                                                            }, {
                                                              default: _withCtx(() => [...(_cache[76] || (_cache[76] = [
                                                                _createTextVNode(" Edit this line ", -1)
                                                              ]))]),
                                                              _: 1
                                                            }),
                                                            _createVNode(_component_v_icon, null, {
                                                              default: _withCtx(() => [...(_cache[77] || (_cache[77] = [
                                                                _createTextVNode("mdi-pencil", -1)
                                                              ]))]),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _: 1
                                                        }, 8, ["onClick"]))
                                                      : _createCommentVNode("", true),
                                                    (_ctx.canDelete || !item.emailId)
                                                      ? (_openBlock(), _createBlock(_component_v_btn, {
                                                          key: 1,
                                                          onClick: ($event: any) => (_ctx.removeEmail(index, false)),
                                                          density: "comfortable",
                                                          size: "small",
                                                          icon: "",
                                                          color: "info"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_tooltip, {
                                                              activator: "parent",
                                                              location: "bottom"
                                                            }, {
                                                              default: _withCtx(() => [...(_cache[78] || (_cache[78] = [
                                                                _createTextVNode(" Delete this line ", -1)
                                                              ]))]),
                                                              _: 1
                                                            }),
                                                            _createVNode(_component_v_icon, null, {
                                                              default: _withCtx(() => [...(_cache[79] || (_cache[79] = [
                                                                _createTextVNode("mdi-delete", -1)
                                                              ]))]),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _: 1
                                                        }, 8, ["onClick"]))
                                                      : _createCommentVNode("", true)
                                                  ])
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          bottom: _withCtx(() => [...(_cache[80] || (_cache[80] = []))]),
                                          _: 2
                                        }, 1032, ["headers", "items"])
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      md: "6"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_data_table, {
                                          headers: _ctx.phoneHeaders,
                                          items: [contactInfo.associatedPhone],
                                          density: "comfortable",
                                          class: "elevation-1",
                                          "hide-default-footer": ""
                                        }, {
                                          "header.actions": _withCtx(({ column }) => [
                                            _createTextVNode(_toDisplayString(column.title) + " ", 1),
                                            (_ctx.canAddPhone(index, false))
                                              ? (_openBlock(), _createBlock(_component_v_btn, {
                                                  key: 0,
                                                  density: "comfortable",
                                                  size: "x-small",
                                                  icon: "",
                                                  color: "info",
                                                  onClick: ($event: any) => (_ctx.addPhone(index, false))
                                                }, {
                                                  default: _withCtx(() => [
                                                    (_ctx.canAddPhone(index, false))
                                                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                                          key: 0,
                                                          activator: "parent",
                                                          location: "bottom"
                                                        }, {
                                                          default: _withCtx(() => [...(_cache[81] || (_cache[81] = [
                                                            _createTextVNode(" Add a phone line (limited to one) ", -1)
                                                          ]))]),
                                                          _: 1
                                                        }))
                                                      : _createCommentVNode("", true),
                                                    _createVNode(_component_v_icon, null, {
                                                      default: _withCtx(() => [...(_cache[82] || (_cache[82] = [
                                                        _createTextVNode("mdi-plus", -1)
                                                      ]))]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 2
                                                }, 1032, ["onClick"]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          "item.isActive": _withCtx(({ item }) => [
                                            item
                                              ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [
                                                  _createElementVNode("td", null, _toDisplayString(item.isActive ? 'Yes' : 'No'), 1)
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          "item.actions": _withCtx(({ item }) => [
                                            item
                                              ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [
                                                  _createElementVNode("td", null, [
                                                    (_ctx.canEnterData)
                                                      ? (_openBlock(), _createBlock(_component_v_btn, {
                                                          key: 0,
                                                          onClick: ($event: any) => (_ctx.editPhone(item, index, false)),
                                                          density: "comfortable",
                                                          size: "small",
                                                          icon: "",
                                                          color: "info"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_tooltip, {
                                                              activator: "parent",
                                                              location: "bottom"
                                                            }, {
                                                              default: _withCtx(() => [...(_cache[83] || (_cache[83] = [
                                                                _createTextVNode(" Edit this line ", -1)
                                                              ]))]),
                                                              _: 1
                                                            }),
                                                            _createVNode(_component_v_icon, null, {
                                                              default: _withCtx(() => [...(_cache[84] || (_cache[84] = [
                                                                _createTextVNode("mdi-pencil", -1)
                                                              ]))]),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _: 1
                                                        }, 8, ["onClick"]))
                                                      : _createCommentVNode("", true),
                                                    (_ctx.canDelete || !item.phoneId)
                                                      ? (_openBlock(), _createBlock(_component_v_btn, {
                                                          key: 1,
                                                          onClick: ($event: any) => (_ctx.removePhone(index, false)),
                                                          density: "comfortable",
                                                          size: "small",
                                                          icon: "",
                                                          color: "info"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_tooltip, {
                                                              activator: "parent",
                                                              location: "bottom"
                                                            }, {
                                                              default: _withCtx(() => [...(_cache[85] || (_cache[85] = [
                                                                _createTextVNode(" Delete this line ", -1)
                                                              ]))]),
                                                              _: 1
                                                            }),
                                                            _createVNode(_component_v_icon, null, {
                                                              default: _withCtx(() => [...(_cache[86] || (_cache[86] = [
                                                                _createTextVNode("mdi-delete", -1)
                                                              ]))]),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _: 1
                                                        }, 8, ["onClick"]))
                                                      : _createCommentVNode("", true)
                                                  ])
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          bottom: _withCtx(() => [...(_cache[87] || (_cache[87] = []))]),
                                          _: 2
                                        }, 1032, ["headers", "items"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_row, null, {
                                  default: _withCtx(() => [
                                    (index === _ctx.eligibility.participantContactInformations.length - 1)
                                      ? (_openBlock(), _createBlock(_component_v_col, {
                                          key: 0,
                                          class: "pb-6"
                                        }, {
                                          default: _withCtx(() => [
                                            (_ctx.canEnterData)
                                              ? (_openBlock(), _createBlock(_component_v_btn, {
                                                  key: 0,
                                                  onClick: _ctx.addContactObject,
                                                  color: "info"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_tooltip, {
                                                      activator: "parent",
                                                      location: "bottom"
                                                    }, {
                                                      default: _withCtx(() => [...(_cache[88] || (_cache[88] = [
                                                        _createTextVNode(" Add a new contact area ", -1)
                                                      ]))]),
                                                      _: 1
                                                    }),
                                                    _cache[89] || (_cache[89] = _createTextVNode(" Add New Contact ", -1))
                                                  ]),
                                                  _: 1
                                                }, 8, ["onClick"]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        }))
                                      : (_openBlock(), _createBlock(_component_v_col, { key: 1 }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_divider, {
                                              thickness: 3,
                                              class: "my-2"
                                            })
                                          ]),
                                          _: 1
                                        }))
                                  ]),
                                  _: 2
                                }, 1024)
                              ]))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_expansion_panel, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_expansion_panel_title, { class: "text-h5" }, {
                          default: _withCtx(() => [...(_cache[90] || (_cache[90] = [
                            _createTextVNode("Emergency Contact Information", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_v_expansion_panel_text, null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eligibility.participantEmergencyContactInformations, (emergencyContactInfo, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: emergencyContactInfo.participantEmergencyContactInformationId
                              }, [
                                _createVNode(_component_v_row, { justify: "space-between" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "4" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_select, {
                                          items: _ctx.contactTypeSelectItems,
                                          "item-value": "id",
                                          "item-title": "description",
                                          label: "Select Contact Type",
                                          modelValue: emergencyContactInfo.contactTypeId,
                                          "onUpdate:modelValue": ($event: any) => ((emergencyContactInfo.contactTypeId) = $event),
                                          readonly: !_ctx.canEnterData
                                        }, null, 8, ["items", "modelValue", "onUpdate:modelValue", "readonly"])
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_v_col, { cols: "4" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_text_field, {
                                          label: "Emergency Contact Name",
                                          modelValue: emergencyContactInfo.contactName,
                                          "onUpdate:modelValue": ($event: any) => ((emergencyContactInfo.contactName) = $event),
                                          readonly: !_ctx.canEnterData
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly"])
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_v_col, {
                                      cols: "4",
                                      style: {"text-align":"end"}
                                    }, {
                                      default: _withCtx(() => [
                                        (_ctx.canDelete && !emergencyContactInfo.participantEmergencyContactInformationId)
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 0,
                                              onClick: ($event: any) => (_ctx.removeEmergencyContactObject(index)),
                                              density: "comfortable",
                                              size: "small",
                                              icon: "",
                                              color: "info"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_tooltip, {
                                                  activator: "parent",
                                                  location: "bottom"
                                                }, {
                                                  default: _withCtx(() => [...(_cache[91] || (_cache[91] = [
                                                    _createTextVNode(" Delete this entire emergency contact area ", -1)
                                                  ]))]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_icon, null, {
                                                  default: _withCtx(() => [...(_cache[92] || (_cache[92] = [
                                                    _createTextVNode("mdi-delete", -1)
                                                  ]))]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }, 8, ["onClick"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_data_table, {
                                          headers: _ctx.addressHeaders,
                                          items: [emergencyContactInfo.associatedAddress],
                                          density: "comfortable",
                                          class: "elevation-1",
                                          "hide-default-footer": ""
                                        }, {
                                          "header.actions": _withCtx(({ column }) => [
                                            _createTextVNode(_toDisplayString(column.title) + " ", 1),
                                            (_ctx.canAddAddress(index, true))
                                              ? (_openBlock(), _createBlock(_component_v_btn, {
                                                  key: 0,
                                                  density: "comfortable",
                                                  size: "x-small",
                                                  icon: "",
                                                  color: "info",
                                                  onClick: ($event: any) => (_ctx.addAddress(index, true))
                                                }, {
                                                  default: _withCtx(() => [
                                                    (_ctx.canAddAddress(index, true))
                                                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                                          key: 0,
                                                          activator: "parent",
                                                          location: "bottom"
                                                        }, {
                                                          default: _withCtx(() => [...(_cache[93] || (_cache[93] = [
                                                            _createTextVNode(" Add an emergency address line (limited to one) ", -1)
                                                          ]))]),
                                                          _: 1
                                                        }))
                                                      : _createCommentVNode("", true),
                                                    _createVNode(_component_v_icon, null, {
                                                      default: _withCtx(() => [...(_cache[94] || (_cache[94] = [
                                                        _createTextVNode("mdi-plus", -1)
                                                      ]))]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 2
                                                }, 1032, ["onClick"]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          "item.isActive": _withCtx(({ item }) => [
                                            item
                                              ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                                                  _createElementVNode("td", null, _toDisplayString(item.isActive ? 'Yes' : 'No'), 1)
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          "item.actions": _withCtx(({ item }) => [
                                            item
                                              ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
                                                  _createElementVNode("td", null, [
                                                    (_ctx.canEnterData)
                                                      ? (_openBlock(), _createBlock(_component_v_btn, {
                                                          key: 0,
                                                          onClick: ($event: any) => (_ctx.editAddress(item, index, true)),
                                                          density: "comfortable",
                                                          size: "small",
                                                          icon: "",
                                                          color: "info"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_tooltip, {
                                                              activator: "parent",
                                                              location: "bottom"
                                                            }, {
                                                              default: _withCtx(() => [...(_cache[95] || (_cache[95] = [
                                                                _createTextVNode(" Edit this line ", -1)
                                                              ]))]),
                                                              _: 1
                                                            }),
                                                            _createVNode(_component_v_icon, null, {
                                                              default: _withCtx(() => [...(_cache[96] || (_cache[96] = [
                                                                _createTextVNode("mdi-pencil", -1)
                                                              ]))]),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _: 1
                                                        }, 8, ["onClick"]))
                                                      : _createCommentVNode("", true),
                                                    (_ctx.canDelete && !item.addressId)
                                                      ? (_openBlock(), _createBlock(_component_v_btn, {
                                                          key: 1,
                                                          onClick: ($event: any) => (_ctx.removeAddress(index, true)),
                                                          density: "comfortable",
                                                          size: "small",
                                                          icon: "",
                                                          color: "info"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_tooltip, {
                                                              activator: "parent",
                                                              location: "bottom"
                                                            }, {
                                                              default: _withCtx(() => [...(_cache[97] || (_cache[97] = [
                                                                _createTextVNode(" Delete this line ", -1)
                                                              ]))]),
                                                              _: 1
                                                            }),
                                                            _createVNode(_component_v_icon, null, {
                                                              default: _withCtx(() => [...(_cache[98] || (_cache[98] = [
                                                                _createTextVNode("mdi-delete", -1)
                                                              ]))]),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _: 1
                                                        }, 8, ["onClick"]))
                                                      : _createCommentVNode("", true)
                                                  ])
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          bottom: _withCtx(() => [...(_cache[99] || (_cache[99] = []))]),
                                          _: 2
                                        }, 1032, ["headers", "items"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      md: "6"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_data_table, {
                                          headers: _ctx.emailHeaders,
                                          items: [emergencyContactInfo.associatedEmail],
                                          density: "comfortable",
                                          class: "elevation-1",
                                          "hide-default-footer": ""
                                        }, {
                                          "header.actions": _withCtx(({ column }) => [
                                            _createTextVNode(_toDisplayString(column.title) + " ", 1),
                                            (_ctx.canAddEmail(index, true))
                                              ? (_openBlock(), _createBlock(_component_v_btn, {
                                                  key: 0,
                                                  density: "comfortable",
                                                  size: "x-small",
                                                  icon: "",
                                                  color: "info",
                                                  onClick: ($event: any) => (_ctx.addEmail(index, true))
                                                }, {
                                                  default: _withCtx(() => [
                                                    (_ctx.canAddEmail(index, true))
                                                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                                          key: 0,
                                                          activator: "parent",
                                                          location: "bottom"
                                                        }, {
                                                          default: _withCtx(() => [...(_cache[100] || (_cache[100] = [
                                                            _createTextVNode(" Add an emergency email line (limited to one) ", -1)
                                                          ]))]),
                                                          _: 1
                                                        }))
                                                      : _createCommentVNode("", true),
                                                    _createVNode(_component_v_icon, null, {
                                                      default: _withCtx(() => [...(_cache[101] || (_cache[101] = [
                                                        _createTextVNode("mdi-plus", -1)
                                                      ]))]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 2
                                                }, 1032, ["onClick"]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          "item.isActive": _withCtx(({ item }) => [
                                            item
                                              ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                                                  _createElementVNode("td", null, _toDisplayString(item.isActive ? 'Yes' : 'No'), 1)
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          "item.actions": _withCtx(({ item }) => [
                                            item
                                              ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                                                  _createElementVNode("td", null, [
                                                    (_ctx.canEnterData)
                                                      ? (_openBlock(), _createBlock(_component_v_btn, {
                                                          key: 0,
                                                          onClick: ($event: any) => (_ctx.editEmail(item, index, true)),
                                                          density: "comfortable",
                                                          size: "small",
                                                          icon: "",
                                                          color: "info"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_tooltip, {
                                                              activator: "parent",
                                                              location: "bottom"
                                                            }, {
                                                              default: _withCtx(() => [...(_cache[102] || (_cache[102] = [
                                                                _createTextVNode(" Edit this line ", -1)
                                                              ]))]),
                                                              _: 1
                                                            }),
                                                            _createVNode(_component_v_icon, null, {
                                                              default: _withCtx(() => [...(_cache[103] || (_cache[103] = [
                                                                _createTextVNode("mdi-pencil", -1)
                                                              ]))]),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _: 1
                                                        }, 8, ["onClick"]))
                                                      : _createCommentVNode("", true),
                                                    (_ctx.canDelete && !item.emailId)
                                                      ? (_openBlock(), _createBlock(_component_v_btn, {
                                                          key: 1,
                                                          onClick: ($event: any) => (_ctx.removeEmail(index, true)),
                                                          density: "comfortable",
                                                          size: "small",
                                                          icon: "",
                                                          color: "info"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_tooltip, {
                                                              activator: "parent",
                                                              location: "bottom"
                                                            }, {
                                                              default: _withCtx(() => [...(_cache[104] || (_cache[104] = [
                                                                _createTextVNode(" Delete this line ", -1)
                                                              ]))]),
                                                              _: 1
                                                            }),
                                                            _createVNode(_component_v_icon, null, {
                                                              default: _withCtx(() => [...(_cache[105] || (_cache[105] = [
                                                                _createTextVNode("mdi-delete", -1)
                                                              ]))]),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _: 1
                                                        }, 8, ["onClick"]))
                                                      : _createCommentVNode("", true)
                                                  ])
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          bottom: _withCtx(() => [...(_cache[106] || (_cache[106] = []))]),
                                          _: 2
                                        }, 1032, ["headers", "items"])
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      md: "6"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_data_table, {
                                          headers: _ctx.phoneHeaders,
                                          items: [emergencyContactInfo.associatedPhone],
                                          density: "comfortable",
                                          class: "elevation-1",
                                          "hide-default-footer": ""
                                        }, {
                                          "header.actions": _withCtx(({ column }) => [
                                            _createTextVNode(_toDisplayString(column.title) + " ", 1),
                                            (_ctx.canAddPhone(index, true))
                                              ? (_openBlock(), _createBlock(_component_v_btn, {
                                                  key: 0,
                                                  density: "comfortable",
                                                  size: "x-small",
                                                  icon: "",
                                                  color: "info",
                                                  onClick: ($event: any) => (_ctx.addPhone(index, true))
                                                }, {
                                                  default: _withCtx(() => [
                                                    (_ctx.canAddPhone(index, true))
                                                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                                          key: 0,
                                                          activator: "parent",
                                                          location: "bottom"
                                                        }, {
                                                          default: _withCtx(() => [...(_cache[107] || (_cache[107] = [
                                                            _createTextVNode(" Add an emergency phone line (limited to one) ", -1)
                                                          ]))]),
                                                          _: 1
                                                        }))
                                                      : _createCommentVNode("", true),
                                                    _createVNode(_component_v_icon, null, {
                                                      default: _withCtx(() => [...(_cache[108] || (_cache[108] = [
                                                        _createTextVNode("mdi-plus", -1)
                                                      ]))]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 2
                                                }, 1032, ["onClick"]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          "item.isActive": _withCtx(({ item }) => [
                                            item
                                              ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
                                                  _createElementVNode("td", null, _toDisplayString(item.isActive ? 'Yes' : 'No'), 1)
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          "item.actions": _withCtx(({ item }) => [
                                            item
                                              ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                                                  _createElementVNode("td", null, [
                                                    (_ctx.canEnterData)
                                                      ? (_openBlock(), _createBlock(_component_v_btn, {
                                                          key: 0,
                                                          onClick: ($event: any) => (_ctx.editPhone(item, index, true)),
                                                          density: "comfortable",
                                                          size: "small",
                                                          icon: "",
                                                          color: "info"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_tooltip, {
                                                              activator: "parent",
                                                              location: "bottom"
                                                            }, {
                                                              default: _withCtx(() => [...(_cache[109] || (_cache[109] = [
                                                                _createTextVNode(" Edit this line ", -1)
                                                              ]))]),
                                                              _: 1
                                                            }),
                                                            _createVNode(_component_v_icon, null, {
                                                              default: _withCtx(() => [...(_cache[110] || (_cache[110] = [
                                                                _createTextVNode("mdi-pencil", -1)
                                                              ]))]),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _: 1
                                                        }, 8, ["onClick"]))
                                                      : _createCommentVNode("", true),
                                                    (_ctx.canDelete || !item.phoneId)
                                                      ? (_openBlock(), _createBlock(_component_v_btn, {
                                                          key: 1,
                                                          onClick: ($event: any) => (_ctx.removePhone(index, true)),
                                                          density: "comfortable",
                                                          size: "small",
                                                          icon: "",
                                                          color: "info"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_tooltip, {
                                                              activator: "parent",
                                                              location: "bottom"
                                                            }, {
                                                              default: _withCtx(() => [...(_cache[111] || (_cache[111] = [
                                                                _createTextVNode(" Delete this line ", -1)
                                                              ]))]),
                                                              _: 1
                                                            }),
                                                            _createVNode(_component_v_icon, null, {
                                                              default: _withCtx(() => [...(_cache[112] || (_cache[112] = [
                                                                _createTextVNode("mdi-delete", -1)
                                                              ]))]),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _: 1
                                                        }, 8, ["onClick"]))
                                                      : _createCommentVNode("", true)
                                                  ])
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          bottom: _withCtx(() => [...(_cache[113] || (_cache[113] = []))]),
                                          _: 2
                                        }, 1032, ["headers", "items"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_row, null, {
                                  default: _withCtx(() => [
                                    (index === _ctx.eligibility.participantEmergencyContactInformations.length - 1)
                                      ? (_openBlock(), _createBlock(_component_v_col, {
                                          key: 0,
                                          class: "pb-6"
                                        }, {
                                          default: _withCtx(() => [
                                            (_ctx.canEnterData)
                                              ? (_openBlock(), _createBlock(_component_v_btn, {
                                                  key: 0,
                                                  onClick: _ctx.addEmergencyContactObject,
                                                  color: "info"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_tooltip, {
                                                      activator: "parent",
                                                      location: "bottom"
                                                    }, {
                                                      default: _withCtx(() => [...(_cache[114] || (_cache[114] = [
                                                        _createTextVNode(" Add a new emergency contact area ", -1)
                                                      ]))]),
                                                      _: 1
                                                    }),
                                                    _cache[115] || (_cache[115] = _createTextVNode(" Add New Emergency Contact ", -1))
                                                  ]),
                                                  _: 1
                                                }, 8, ["onClick"]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        }))
                                      : (_openBlock(), _createBlock(_component_v_col, { key: 1 }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_divider, {
                                              thickness: 3,
                                              class: "my-2"
                                            })
                                          ]),
                                          _: 1
                                        }))
                                  ]),
                                  _: 2
                                }, 1024)
                              ]))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_expansion_panel, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_expansion_panel_title, { class: "text-h5" }, {
                          default: _withCtx(() => [...(_cache[116] || (_cache[116] = [
                            _createTextVNode("Judicial History", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_v_expansion_panel_text, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  md: "4"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                      type: "string",
                                      label: "Selected Current Criminal Status",
                                      modelValue: _ctx.eligibility.participantCriminalStatus.adjudicationTypeId,
                                      "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.eligibility.participantCriminalStatus.adjudicationTypeId) = $event)),
                                      readonly: true
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  md: "4"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                      type: "number",
                                      min: "0",
                                      onKeypress: _cache[39] || (_cache[39] = ($event: any) => (_ctx.filterOnlyNumbers($event))),
                                      label: "Previous Felony Count",
                                      modelValue: _ctx.eligibility.participantCriminalStatus.previousFelonyCount,
                                      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.eligibility.participantCriminalStatus.previousFelonyCount) = $event)),
                                      readonly: !_ctx.canEnterData
                                    }, null, 8, ["modelValue", "readonly"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  md: "4"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                      type: "number",
                                      min: "0",
                                      onKeypress: _cache[41] || (_cache[41] = ($event: any) => (_ctx.filterOnlyNumbers($event))),
                                      label: "Previous Midemeanor Count",
                                      modelValue: _ctx.eligibility.participantCriminalStatus.previousMisdemeanorCount,
                                      "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.eligibility.participantCriminalStatus.previousMisdemeanorCount) = $event)),
                                      readonly: !_ctx.canEnterData
                                    }, null, 8, ["modelValue", "readonly"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_data_table, {
                                      headers: _ctx.criminalHistoryOptionsHeaders,
                                      items: _ctx.eligibility.participantCriminalHistories,
                                      class: "elevation-1"
                                    }, {
                                      "item.adjudicationType": _withCtx(({ item }) => [
                                        _createVNode(_component_v_select, {
                                          items: _ctx.adjudicationTypeSelectItems,
                                          "item-value": "id",
                                          "item-title": "description",
                                          label: "Status",
                                          modelValue: item.adjudicationTypeId,
                                          "onUpdate:modelValue": ($event: any) => ((item.adjudicationTypeId) = $event),
                                          readonly: !_ctx.canEnterData
                                        }, {
                                          selection: _withCtx(({ item }) => [
                                            _createElementVNode("span", null, _toDisplayString(item.title), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["items", "modelValue", "onUpdate:modelValue", "readonly"])
                                      ]),
                                      "item.caseNumber": _withCtx(({ item }) => [
                                        _createVNode(_component_v_text_field, {
                                          modelValue: item.caseNumber,
                                          "onUpdate:modelValue": ($event: any) => ((item.caseNumber) = $event),
                                          readonly: !_ctx.canEnterData
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly"])
                                      ]),
                                      "item.arrestDate": _withCtx(({ item }) => [
                                        _createVNode(_component_v_text_field, {
                                          type: "date",
                                          modelValue: item.arrestDate,
                                          "onUpdate:modelValue": ($event: any) => ((item.arrestDate) = $event),
                                          readonly: !_ctx.canEnterData
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly"])
                                      ]),
                                      "item.chargeType": _withCtx(({ item }) => [
                                        _createVNode(_component_v_select, {
                                          items: _ctx.chargeTypeSelectItems,
                                          clearable: "",
                                          "item-value": "id",
                                          "item-title": "description",
                                          modelValue: item.chargeTypeId,
                                          "onUpdate:modelValue": ($event: any) => ((item.chargeTypeId) = $event),
                                          readonly: !_ctx.canEnterData
                                        }, {
                                          selection: _withCtx(({ item }) => [
                                            _createElementVNode("span", null, _toDisplayString(_ctx.getAbbreviatedText(item.title)), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["items", "modelValue", "onUpdate:modelValue", "readonly"])
                                      ]),
                                      "item.arrestCharge": _withCtx(({ item }) => [
                                        _createVNode(_component_v_select, {
                                          items: _ctx.chargeTypeSelectItems,
                                          clearable: "",
                                          "item-value": "id",
                                          "item-title": "description",
                                          modelValue: item.arrestHistoryId,
                                          "onUpdate:modelValue": ($event: any) => ((item.arrestHistoryId) = $event),
                                          readonly: !_ctx.canEnterData
                                        }, {
                                          selection: _withCtx(({ item }) => [
                                            _createElementVNode("span", null, _toDisplayString(_ctx.getAbbreviatedText(item.title)), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["items", "modelValue", "onUpdate:modelValue", "readonly"])
                                      ]),
                                      "item.citation": _withCtx(({ item }) => [
                                        _createVNode(_component_v_select, {
                                          items: _ctx.chargeTypeSelectItems,
                                          clearable: "",
                                          "item-value": "id",
                                          "item-title": "description",
                                          modelValue: item.citationId,
                                          "onUpdate:modelValue": ($event: any) => ((item.citationId) = $event),
                                          readonly: !_ctx.canEditRolePermission
                                        }, {
                                          selection: _withCtx(({ item }) => [
                                            _createElementVNode("span", null, _toDisplayString(_ctx.getAbbreviatedText(item.title)), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["items", "modelValue", "onUpdate:modelValue", "readonly"])
                                      ]),
                                      "item.drugOrAlcoholRelated": _withCtx(({ item }) => [
                                        _createVNode(_component_v_select, {
                                          items: _ctx.drugOrAlcoholSelectItems,
                                          "item-value": "id",
                                          "item-title": "description",
                                          modelValue: item.drugOrAlcoholRelatedId,
                                          "onUpdate:modelValue": ($event: any) => ((item.drugOrAlcoholRelatedId) = $event),
                                          readonly: !_ctx.canEnterData
                                        }, null, 8, ["items", "modelValue", "onUpdate:modelValue", "readonly"])
                                      ]),
                                      "item.bac": _withCtx(({ item }) => [
                                        _createVNode(_component_v_text_field, {
                                          type: "number",
                                          modelValue: item.bac,
                                          "onUpdate:modelValue": ($event: any) => ((item.bac) = $event),
                                          readonly: !_ctx.canEnterData
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly"])
                                      ]),
                                      "item.degree": _withCtx(({ item }) => [
                                        _createVNode(_component_v_select, {
                                          items: _ctx.degreeSelectItems,
                                          "item-value": "id",
                                          "item-title": "description",
                                          modelValue: item.degreeId,
                                          "onUpdate:modelValue": ($event: any) => ((item.degreeId) = $event),
                                          readonly: !_ctx.canEnterData
                                        }, null, 8, ["items", "modelValue", "onUpdate:modelValue", "readonly"])
                                      ]),
                                      "item.actions": _withCtx(({ item, index }) => [
                                        (_ctx.canDelete || !item.participantCriminalHistoryId)
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 0,
                                              onClick: ($event: any) => (_ctx.removeCriminalHistory(index)),
                                              density: "comfortable",
                                              size: "small",
                                              icon: "mdi-delete",
                                              color: "info"
                                            }, null, 8, ["onClick"]))
                                          : _createCommentVNode("", true),
                                        _cache[117] || (_cache[117] = _createElementVNode("span", { class: "ma-1" }, null, -1)),
                                        (_ctx.eligibility.participantCriminalHistories.findIndex(e => e === item) === _ctx.eligibility.participantCriminalHistories.length - 1)
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 1,
                                              onClick: _cache[43] || (_cache[43] = ($event: any) => (_ctx.addCriminalHistory())),
                                              density: "comfortable",
                                              size: "small",
                                              icon: "mdi-plus",
                                              color: "info",
                                              disabled: !_ctx.canAddCriminalHistory
                                            }, null, 8, ["disabled"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }, 8, ["headers", "items"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_divider, {
                              thickness: 2,
                              class: "pb-6"
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_expansion_panel, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_expansion_panel_title, { class: "text-h5" }, {
                          default: _withCtx(() => [...(_cache[118] || (_cache[118] = [
                            _createTextVNode("Assessment Scores", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_v_expansion_panel_text, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_data_table, {
                                      headers: _ctx.assessmentOptionsHeaders,
                                      items: _ctx.eligibility.participantAssessments
                                    }, {
                                      "item.assessmentType": _withCtx(({ item }) => [
                                        _createVNode(_component_v_select, {
                                          items: _ctx.assessmentTypeSelectItems,
                                          "item-value": "id",
                                          "item-title": "description",
                                          modelValue: item.assessmentTypeId,
                                          "onUpdate:modelValue": ($event: any) => ((item.assessmentTypeId) = $event),
                                          readonly: !_ctx.canEnterData
                                        }, null, 8, ["items", "modelValue", "onUpdate:modelValue", "readonly"])
                                      ]),
                                      "item.score": _withCtx(({ item }) => [
                                        _createVNode(_component_v_text_field, {
                                          type: "number",
                                          modelValue: item.score,
                                          "onUpdate:modelValue": ($event: any) => ((item.score) = $event),
                                          readonly: !_ctx.canEnterData
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly"])
                                      ]),
                                      "item.dateTaken": _withCtx(({ item }) => [
                                        _createVNode(_component_v_text_field, {
                                          type: "date",
                                          modelValue: item.dateTaken,
                                          "onUpdate:modelValue": ($event: any) => ((item.dateTaken) = $event),
                                          readonly: !_ctx.canEnterData
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly"])
                                      ]),
                                      "item.riskLevel": _withCtx(({ item }) => [
                                        _createVNode(_component_v_select, {
                                          items: _ctx.riskLevelSelectItems,
                                          "item-value": "id",
                                          "item-title": "description",
                                          modelValue: item.riskLevelId,
                                          "onUpdate:modelValue": ($event: any) => ((item.riskLevelId) = $event),
                                          readonly: !_ctx.canEnterData
                                        }, null, 8, ["items", "modelValue", "onUpdate:modelValue", "readonly"])
                                      ]),
                                      "item.needLevel": _withCtx(({ item }) => [
                                        _createVNode(_component_v_select, {
                                          items: _ctx.needLevelSelectItems,
                                          "item-value": "id",
                                          "item-title": "description",
                                          modelValue: item.needLevelId,
                                          "onUpdate:modelValue": ($event: any) => ((item.needLevelId) = $event),
                                          readonly: !_ctx.canEnterData
                                        }, null, 8, ["items", "modelValue", "onUpdate:modelValue", "readonly"])
                                      ]),
                                      "item.actions": _withCtx(({ item, index }) => [
                                        (_ctx.canDelete || !item.participantAssessmentId)
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 0,
                                              onClick: ($event: any) => (_ctx.removeAssessment(index)),
                                              density: "comfortable",
                                              size: "small",
                                              icon: "mdi-delete",
                                              color: "info"
                                            }, null, 8, ["onClick"]))
                                          : _createCommentVNode("", true),
                                        _cache[119] || (_cache[119] = _createElementVNode("span", { class: "ma-1" }, null, -1)),
                                        (_ctx.eligibility.participantAssessments.findIndex(e => e === item) === _ctx.eligibility.participantAssessments.length - 1)
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 1,
                                              onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.addAssessment())),
                                              density: "comfortable",
                                              size: "small",
                                              icon: "mdi-plus",
                                              color: "info",
                                              disabled: !_ctx.canAddAssessment
                                            }, null, 8, ["disabled"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }, 8, ["headers", "items"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_divider, {
                              thickness: 2,
                              class: "pb-6"
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_expansion_panel, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_expansion_panel_title, { class: "text-h5" }, {
                          default: _withCtx(() => [...(_cache[120] || (_cache[120] = [
                            _createTextVNode("Document Upload", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_v_expansion_panel_text, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_DocumentList, {
                              parentId: _ctx.eligibilityId,
                              parentTypeId: _ctx.parentTypeId,
                              canUpload: _ctx.canEnterData,
                              canDelete: _ctx.canDelete
                            }, null, 8, ["parentId", "parentTypeId", "canUpload", "canDelete"]),
                            _createVNode(_component_v_divider, {
                              thickness: 2,
                              class: "pb-6"
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_expansion_panel, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_expansion_panel_title, { class: "text-h5" }, {
                          default: _withCtx(() => [...(_cache[121] || (_cache[121] = [
                            _createTextVNode("Diagnosis Selection", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_v_expansion_panel_text, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_data_table, {
                                      headers: _ctx.diagnosisOptionsHeaders,
                                      items: _ctx.eligibility.participantDiagnoses
                                    }, {
                                      "item.diagnosis": _withCtx(({ item }) => [
                                        _createVNode(_component_v_autocomplete, {
                                          items: _ctx.diagnosisSelectItems,
                                          "item-value": "id",
                                          "item-title": "description",
                                          modelValue: item.diagnosisId,
                                          "onUpdate:modelValue": ($event: any) => ((item.diagnosisId) = $event),
                                          readonly: !_ctx.canEnterData
                                        }, null, 8, ["items", "modelValue", "onUpdate:modelValue", "readonly"])
                                      ]),
                                      "item.actions": _withCtx(({ item }) => [
                                        (_ctx.canDelete || !item.participantDiagnosisId)
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 0,
                                              onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.removeDiagnosis(_ctx.index))),
                                              density: "comfortable",
                                              size: "small",
                                              icon: "mdi-delete",
                                              color: "info"
                                            }))
                                          : _createCommentVNode("", true),
                                        _cache[122] || (_cache[122] = _createElementVNode("span", { class: "ma-1" }, null, -1)),
                                        (_ctx.eligibility.participantDiagnoses.findIndex(e => e === item) === _ctx.eligibility.participantDiagnoses.length - 1)
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 1,
                                              onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.addDiagnosis())),
                                              density: "comfortable",
                                              size: "small",
                                              icon: "mdi-plus",
                                              color: "info",
                                              disabled: !_ctx.canAddDiagnosis
                                            }, null, 8, ["disabled"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }, 8, ["headers", "items"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_divider, {
                              thickness: 2,
                              class: "pb-6"
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_expansion_panel, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_expansion_panel_title, { class: "text-h5" }, {
                          default: _withCtx(() => [...(_cache[123] || (_cache[123] = [
                            _createTextVNode("Past Treatment Selection", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_v_expansion_panel_text, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_data_table, {
                                      headers: _ctx.treatmentOptionsHeaders,
                                      items: _ctx.eligibility.participantTreatments
                                    }, {
                                      "item.treatmentType": _withCtx(({ item }) => [
                                        _createVNode(_component_v_autocomplete, {
                                          items: _ctx.treatmentTypeSelectItems,
                                          "item-value": "id",
                                          "item-title": "description",
                                          modelValue: item.treatmentTypeId,
                                          "onUpdate:modelValue": ($event: any) => ((item.treatmentTypeId) = $event),
                                          readonly: !_ctx.canEnterData
                                        }, null, 8, ["items", "modelValue", "onUpdate:modelValue", "readonly"])
                                      ]),
                                      "item.actions": _withCtx(({ item }) => [
                                        (_ctx.canDelete && !item.participantTreatmentId)
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 0,
                                              onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.removeTreatment(_ctx.index))),
                                              density: "comfortable",
                                              size: "small",
                                              icon: "mdi-delete",
                                              color: "info"
                                            }))
                                          : _createCommentVNode("", true),
                                        _cache[124] || (_cache[124] = _createElementVNode("span", { class: "ma-1" }, null, -1)),
                                        (_ctx.eligibility.participantTreatments.findIndex(e => e === item) === _ctx.eligibility.participantTreatments.length - 1)
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 1,
                                              onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.addTreatment())),
                                              density: "comfortable",
                                              size: "small",
                                              icon: "mdi-plus",
                                              color: "info",
                                              disabled: !_ctx.canAddTreatment
                                            }, null, 8, ["disabled"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }, 8, ["headers", "items"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_divider, {
                              thickness: 2,
                              class: "pb-6"
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_expansion_panel, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_expansion_panel_title, { class: "text-h5" }, {
                          default: _withCtx(() => [...(_cache[125] || (_cache[125] = [
                            _createTextVNode("Notes", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_ValidationAlert, { validationResults: _ctx.validationMessages }, null, 8, ["validationResults"]),
                        _createVNode(_component_AddEligibilityNoteDialog, {
                          modelValue: _ctx.showNoteDialog,
                          "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.showNoteDialog) = $event)),
                          sourceText: _ctx.selectedNote.note,
                          headerText: _ctx.noteHeader,
                          onClose: _ctx.cancelNoteEdit,
                          onSave: _ctx.saveNote
                        }, null, 8, ["modelValue", "sourceText", "headerText", "onClose", "onSave"]),
                        _createVNode(_component_ConfirmDialog, {
                          dialogIsOpen: _ctx.showDeleteWarning,
                          onConfirm: _cache[50] || (_cache[50] = ($event: any) => (_ctx.confirmDelete())),
                          onCancel: _ctx.cancelDelete,
                          dialogText: _ctx.deleteWarningText
                        }, null, 8, ["dialogIsOpen", "onCancel", "dialogText"]),
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_data_table, {
                                  headers: _ctx.noteHeaders,
                                  items: _ctx.notes
                                }, _createSlots({
                                  [`item.createDate`]: _withCtx(({ item }) => [
                                    _createTextVNode(_toDisplayString(_ctx.formatDate(item.createDate)), 1)
                                  ]),
                                  _: 2
                                }, [
                                  (_ctx.canEditRolePermission)
                                    ? {
                                        name: `item.actions`,
                                        fn: _withCtx(({ item }) => [
                                          _createVNode(_component_v_btn, {
                                            onClick: ($event: any) => (_ctx.editNote(item)),
                                            class: "ma-1",
                                            density: "comfortable",
                                            size: "small",
                                            icon: "mdi-pencil-outline",
                                            color: "info"
                                          }, null, 8, ["onClick"]),
                                          _createVNode(_component_v_btn, {
                                            onClick: ($event: any) => (_ctx.deleteNote(item.eligibilityNoteId)),
                                            class: "ma-1",
                                            density: "comfortable",
                                            size: "small",
                                            icon: "mdi-trash-can-outline",
                                            color: "error"
                                          }, null, 8, ["onClick"])
                                        ]),
                                        key: "0"
                                      }
                                    : undefined
                                ]), 1032, ["headers", "items"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_row, { class: "mt-2" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { align: "center" }, {
                              default: _withCtx(() => [
                                _withDirectives(_createVNode(_component_v_btn, {
                                  onClick: _ctx.newNote,
                                  color: "primary"
                                }, {
                                  default: _withCtx(() => [...(_cache[126] || (_cache[126] = [
                                    _createTextVNode("Add New Note", -1)
                                  ]))]),
                                  _: 1
                                }, 8, ["onClick"]), [
                                  [_vShow, _ctx.canEditRolePermission]
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_ctx.canEnterData)
                      ? (_openBlock(), _createBlock(_component_v_expansion_panel, { key: 0 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_expansion_panel_title, { class: "text-h5" }, {
                              default: _withCtx(() => [...(_cache[127] || (_cache[127] = [
                                _createTextVNode("Save Progress", -1)
                              ]))]),
                              _: 1
                            }),
                            _createVNode(_component_v_expansion_panel_text, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ValidationAlert, { "validation-results": _ctx.saveValidationResults }, null, 8, ["validation-results"]),
                                    _createVNode(_component_v_col, { align: "center" }, {
                                      default: _withCtx(() => [
                                        _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                          class: "mx-2 mb-4",
                                          color: "success",
                                          onClick: _cache[51] || (_cache[51] = ($event: any) => (_ctx.submitSave(true))),
                                          disabled: _ctx.isSaving
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.saveButtonText), 1)
                                          ]),
                                          _: 1
                                        }, 8, ["disabled"])), [
                                          [_directive_ripple]
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.canEditRolePermission)
                      ? (_openBlock(), _createBlock(_component_v_expansion_panel, { key: 1 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_expansion_panel_title, { class: "text-h5" }, {
                              default: _withCtx(() => [...(_cache[128] || (_cache[128] = [
                                _createTextVNode("Workflow Status", -1)
                              ]))]),
                              _: 1
                            }),
                            _createVNode(_component_v_expansion_panel_text, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ValidationAlert, { "validation-results": _ctx.validationResults }, null, 8, ["validation-results"]),
                                _createVNode(_component_AlternateWorkflowSubmission, {
                                  caseId: _ctx.eligibility.caseId,
                                  parentId: _ctx.eligibility.eligibilityId,
                                  workflowInstanceId: _ctx.eligibility.workflowInstanceId,
                                  type: _ctx.workflowType,
                                  onSuccess: _ctx.saveWorkflow,
                                  onError: _ctx.saveWorkflow
                                }, null, 8, ["caseId", "parentId", "workflowInstanceId", "type", "onSuccess", "onError"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_expansion_panel, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_expansion_panel_title, { class: "text-h5" }, {
                          default: _withCtx(() => [...(_cache[129] || (_cache[129] = [
                            _createTextVNode("Workflow History", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_v_expansion_panel_text, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_WorkflowHistory, {
                              workflowInstanceId: _ctx.eligibility.workflowInstanceId
                            }, null, 8, ["workflowInstanceId"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_AddAddressDialog, {
              modelValue: _ctx.showAddressDialog,
              "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.showAddressDialog) = $event)),
              source: _ctx.selectedAddress,
              headerText: _ctx.dialogText,
              onClose: _cache[54] || (_cache[54] = ($event: any) => (_ctx.showAddressDialog = false)),
              onSave: _ctx.saveAddress
            }, null, 8, ["modelValue", "source", "headerText", "onSave"]),
            _createVNode(_component_AddEmailDialog, {
              modelValue: _ctx.showEmailDialog,
              "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.showEmailDialog) = $event)),
              source: _ctx.selectedEmail,
              headerText: _ctx.dialogText,
              onClose: _cache[56] || (_cache[56] = ($event: any) => (_ctx.showEmailDialog = false)),
              onSave: _ctx.saveEmail
            }, null, 8, ["modelValue", "source", "headerText", "onSave"]),
            _createVNode(_component_AddPhoneDialog, {
              modelValue: _ctx.showPhoneDialog,
              "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.showPhoneDialog) = $event)),
              source: _ctx.selectedPhone,
              headerText: _ctx.dialogText,
              onClose: _cache[58] || (_cache[58] = ($event: any) => (_ctx.showPhoneDialog = false)),
              onSave: _ctx.savePhone
            }, null, 8, ["modelValue", "source", "headerText", "onSave"]),
            _createVNode(_component_v_snackbar, {
              color: "success",
              modelValue: _ctx.successNotification,
              "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.successNotification) = $event)),
              timeout: "2000"
            }, {
              default: _withCtx(() => [...(_cache[130] || (_cache[130] = [
                _createTextVNode("Submission Saved Successfully!", -1)
              ]))]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
}